/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|modules|herbal-cart|components|herbal-cartlineitem'] = {
                c: () => require('partner/modules/herbal-cart/components/herbal-cartlineitem.component.tsx'),
                cn: '__local__-__local__-herbal-cartlineitem'
            };
componentDictionary['__local__|__local__|modules|herbal-order-confirmation|components|cartline|order-confirmation-cartlineitem'] = {
                c: () => require('partner/modules/herbal-order-confirmation/components/cartline/order-confirmation-cartlineitem.component.tsx'),
                cn: '__local__-__local__-order-confirmation-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|carticon'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|cartlineitem'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|herbalcartlineitem'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/herbalcartlineitem.component.tsx'),
                cn: '__local__-__local__-herbalcartlineitem'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|product'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|promocode'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|herbal-adventureworks|views|components|wishlist-icon'] = {
                c: () => require('partner/themes/herbal-adventureworks/views/components/wishlist-icon.component.tsx'),
                cn: '__local__-__local__-wishlist-icon'
            };
componentDictionary['__local__|__local__|themes|herbalextractheme|views|components|cartlineitem'] = {
                c: () => require('partner/themes/herbalextractheme/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|herbalextractheme|views|components|promocode'] = {
                c: () => require('partner/themes/herbalextractheme/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product-v2'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product-v2.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
            };